import React, { useEffect, useState } from "react";
import Input from "./Input";
import Select from "./Select";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Switch from "react-switch";
import { Link } from "react-router-dom";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { Multiselect } from "multiselect-react-dropdown";
import { Table } from "react-bootstrap";
import swal from "sweetalert";
import {useHistory} from 'react-router-dom'
import {Modal} from "react-bootstrap";
export default function AddProducts(props) {
  const history=useHistory()
  const [tags, setTags] = React.useState([]);
  const [name, setName] = useState("");
  const [popular, setPopular] = useState(false);
  const [show, setShow] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [imageUpdateStatus, setImageUpdateStatus] = useState(false);
  const [newItem, setNewItem] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [city, setCity] = useState('');
  const [codeProduct, setCodeProduct] = useState("");
  const [shefLife, setShefLife] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [itemId, setItemId] = useState("");
  const [unit, setUnit] = useState("");
  const [cost, setCost] = useState("");
  const [updateCost, setUpdateCost] = useState("");
  const [priceId, setPriceId] = useState("");
  const [unitNumber, setUnitNumber] = useState("");
  const [noOfPackets, setNoOfPackets] = useState(1);
  const [discount, setDiscount] = useState("");
  const [updateDiscount, setUpdateDiscount] = useState("");
  const [pricingArray, setPricingArray] = useState([]);
  const [galleryImg, setGalleryImg] = useState([]);
  const [galleryUpdateImg, setGalleryUpdateImg] = useState([]);
  const [image, setImage] = useState([]);
  const [productDescription, setProductDescription] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [allSubCategory, setAllSubCategory] = useState([]);
  const [availability, setAvailability] = useState([]);
  const [selectedAvailability, setSelectedAvailability] = useState([]);

  const availabilityArray = [ "Morning","Afternoon" , "Evening" ,"Night"];
  const cityObject = [
    "Bengaluru",
    "Mumbai",
    "Chennai",
    "Hyderabad",
    "Delhi",
    "Kolkotta",
  ];
 

  const units = ["g", "kg", "ml", "ltr", "mtr"];
  const addTags = (event) => {
    if (event.key === "Enter" && event.target.value !== "") {
      setTags([...tags, event.target.value]);
      event.target.value = "";
    }
  };
  const removeTags = (index) => {
    setTags([...tags.filter((tag) => tags.indexOf(tag) !== index)]);
  };
  
  function getData() {

    axios
      .get(`${Baseurl.baseurl6}/go-grocery/category/get-all-grocery-category`)
      .then((res) => {
        setAllCategory(res.data.details);
        console.log("vikki",res.data.details)
        if(props.location.state!==undefined){
          res.data.details.map((val)=>{
            if(props.location.state.CategoryId._id===val._id){
              setAllSubCategory(val.SubCategory)
            }
          })
        }
      });
  }
  useEffect(() => {
    if(props.location.state!==undefined){
      setItemId(props.location.state._id)
      setUpdateStatus(true)
      setName(props.location.state.Name)
      setCodeProduct(props.location.state.Barcode)
      setUnit(props.location.state.Unit)
      setUnitNumber(props.location.state.UnitNumber)
      setNoOfPackets(props.location.state.Packets)
      setNoOfPackets(props.location.state.Packets)
      setTags(props.location.state.Tags)
      setPopular(props.location.state.Popular)
      setNewItem(props.location.state.New)
      setGalleryImg(props.location.state.Image)
      setPricingArray(props.location.state.Price)
      setShefLife(props.location.state.ShefLife)
      setProductDescription(props.location.state.Description)
      setCategory(props.location.state.CategoryId._id)

      setSubCategory(props.location.state.SubCategoryId._id)
      let vikki=[]
      console.log('props',props.location.state)
      if(props.location.state.Evening){
        vikki.push("Evening")
      }
      if(props.location.state.Morning){
        vikki.push("Morning")
      }
      if(props.location.state.Afternoon){
        vikki.push("Afternoon")
      }
      if(props.location.state.Night){
        vikki.push("Night")
      }
      setSelectedAvailability(vikki)
    }
    else{
      setUpdateStatus(false)
    }
    getData();
  }, []);
  const selection1 = (selectedValues) => {
    console.log("selectionsss",selectedValues)
    let name = [];
    selectedValues.map((val) => {
      name.push(val);
    });
    
    setAvailability(name);
  };
  function createProduct(){
    const data = new FormData();
    let article={
    CategoryId:category,
    SubCategoryId:subCategory,
    Name:name,
    Unit:unit,
    UnitNumber:unitNumber,
    Tags:tags,
    Price:pricingArray,
    Description:productDescription,
    ShefLife:shefLife,
    ExpiryDate:"",
    MName:"GoOne",
    MAddress:"Bombay",
    MFssaiCode:"12hbhejcbjrj48483937b",
    Morning:availability.includes("Morning"),
    Afternoon:availability.includes("Afternoon"),
    Evening:availability.includes("Evening"),
    Night:availability.includes("Night"),
    Popular:popular,
    New:newItem,
    Barcode:codeProduct,
    Packets:noOfPackets
    }
    image.map((val)=>{
     data.append("images", val);
    })
    data.append("data",JSON.stringify(article) );
    var config = {
      method: "post",
      url: `${Baseurl.baseurl6}/go-grocery/item/create-grocery-item`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          history.goBack()
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function updateProduct(){
    let catFields = {
      Name:name,
      Barcode: codeProduct,
      Packets: noOfPackets,
      Unit: unit,
      UnitNumber: unitNumber,
      Description:productDescription,
      ShefLife:shefLife,
      ExpiryDate: "",
      MName: "",
      MAddress: "",
      MFssaiCode: "",
      Morning:availability.includes("Morning"),
      Afternoon:availability.includes("Afternoon"),
      Evening:availability.includes("Evening"),
      Night:availability.includes("Night"),
      Popular: popular,
      New: newItem,
      Tags:tags,
      // SubCategoryId:category,
      // CategoryId:subCategory
    };
    let fields={
      data:JSON.stringify(catFields)
    }
    axios
      .put(
        `${Baseurl.baseurl6}/go-grocery/item/update-grocery-item-details/${itemId}`,
        fields
      )
      .then((response) => {
        if (response.data.status) {
          history.goBack()
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updateImage(){
    const data = new FormData();
    image.map((val)=>{
      data.append("images", val);
     })
     var config = {
       method: "put",
       url: `${Baseurl.baseurl6}/go-grocery/item/update-grocery-item-image/${itemId}`,
       data: data,
     };
 
     axios(config)
       .then(function (response) {
         if (response.data.status) {
           swal("Updated", response.data.message, "success", {
             button: "Done",
             timer: 1000,
           });
           history.goBack()
         } else {
           swal("Oops", response.data.message, "error", {
             button: "Done",
             timer: 1000,
           });
         }
       })
       .catch((err) => {});
  }
  function updateCityPrice(){
    let catFields = {
      CityName:city,
      Price:cost,
      OfferPrice:discount,
    };
    let fields={
      price:JSON.stringify(catFields)
    }
    axios
      .put(
        `${Baseurl.baseurl6}/go-grocery/item/add-item-price-details/${itemId}`,
        fields  
      )
      .then((response) => {
        if (response.data.status) {
          history.goBack()
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        
      });
  }
  function updateParticularPrice(){
    let catFields = {
      priceId:priceId,
      price:updateCost,
      offerPrice:updateDiscount
    };
 
    axios
      .put(
        `${Baseurl.baseurl6}/go-grocery/item/update-item-price-details/${itemId}`,
        catFields  
      )
      .then((response) => {
        if (response.data.status) {
          history.goBack()
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        
      });
  }
  function deleteParticularPricing(){
    let catFields = {
      priceId:priceId,
    };
 
    axios
      .put(
        `${Baseurl.baseurl6}/go-grocery/item/remove-item-price-details/${itemId}`,
        catFields  
      )
      .then((response) => {
        if (response.data.status) {
          history.goBack()
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        
      });
  }
  return (
    <>
     <Modal
     centered
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >

        <Modal.Body>
          {deleteStatus?(
            <h4>Are you sure ! you want to deleted this pricing</h4>
          ):(
            <>
            <div className="row">
          <div className="col-sm-2 mt-1">
              <label className="col-form-label" htmlFor="val-confirm-password">
                 Price<span className="text-danger">*</span>
              </label>
            </div>

            <div className="col-sm-10">
              <Input
                type="number"
                defaultName={updateCost}
                setName={setUpdateCost}
                placeHolder="Enter Price"
              />
            </div>
           
          </div>
          <div className="row mt-4">
          <div className="col-sm-2 mt-1">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Discount Price<span className="text-danger">*</span>
              </label>
            </div>
            <div className="col-sm-10">
              <Input
                type="number"
                defaultName={updateDiscount}
                setName={setUpdateDiscount}
                placeHolder="enter discount price"
              />
            </div>
          </div></>
          )}
          
        </Modal.Body>
        <Modal.Footer>
          {deleteStatus?(
             <button
             onClick={() => {
              deleteParticularPricing()
             }}
             style={{borderRadius:'10px'}}
             className="btn btn-danger p-2"
           >
             Delete
           </button>
          ):(
            <button
            onClick={() => {
             updateParticularPrice()
            }}
            style={{borderRadius:'10px'}}
            className="btn btn-primary p-2"
          >
            update
          </button>
          )}
         
        </Modal.Footer>
      </Modal>
      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <strong>Product Information</strong>
         {updateStatus&&( <small class="text-white ">
                You can update the field by botton update button
                </small>)}
        </div>
       
        <div className="card-body">
          <div className="row">
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Name <span className="text-danger">*</span>
              </label>
            </div>

            <div className="col-sm-4">
              <Input
                type="text"
                defaultName={name}
                setName={setName}
                placeHolder="Enter Product Name"
              />
            </div>
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Category<span className="text-danger">*</span>
              </label>
            </div>
            <div className="col-sm-4">
              <select
                className="form-control"
                id="val-skill"
                name="val-skill"
                value={category}
                onChange={(event) => {
                  setCategory(event.target.value);
                  allCategory.map((val)=>{
                    if(val._id===event.target.value){
                      setAllSubCategory(val.SubCategory)
                    }
                  })
                  
                }}
              >
                <option selected="true" disabled="disabled"></option>
                {allCategory.map((val) => {
                  return <option value={val._id}>{val.Name}</option>;
                })}
              </select>
            </div>
          </div>
          
          <div className="row mt-3">
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Sub Category
              </label>
            </div>
            <div className="col-sm-4">
              <select
                className="form-control"
                id="val-skill"
                name="val-skill"
                value={subCategory}
                onChange={(event) => {
                  setSubCategory(event.target.value);
                }}
              >
                <option selected="true" disabled="disabled"></option>
                {allSubCategory.map((val) => {
                  return <option value={val._id}>{val.Name}</option>;
                })}
              </select>
            </div>

            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                EAN Code
              </label>
            </div>
            <div className="col-sm-4">
              <Input
                type="text"
                defaultName={codeProduct}
                setName={setCodeProduct}
                placeHolder=""
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Product Unit
              </label>
            </div>
            <div className="col-sm-4">
              <Select value={unit} options={units} setValues={setUnit} />
            </div>
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Unit Number<span className="text-danger">*</span>
              </label>
            </div>

            <div className="col-sm-4">
              <Input
                type="number"
                defaultName={unitNumber}
                setName={setUnitNumber}
                placeHolder=""
              />
            </div>
          </div>
          <div className="row mt-3">
          <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
              No of Packets<span className="text-danger">*</span>
              </label>
            </div>

            <div className="col-sm-4">
              <Input
                type="number"
                defaultName={noOfPackets}
                setName={setNoOfPackets}
                placeHolder=""
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Tags
              </label>
            </div>
            <div className="col-sm-4">
              <input
                type="text"
                placeholder="Press enter to add tags"
                className="form-control"
                onKeyUp={(event) => addTags(event)}
              ></input>
              <ul className="row">
                {tags.map((tag, index) => (
                  <li key={index} className="ml-2 mt-2">
                    <span>{tag}</span>
                    <Link
                      onClick={() => removeTags(index)}
                      className="btn btn-danger shadow btn-xs sharp ml-1"
                    >
                      <i  className="fa fa-close"></i>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
               Availability
              </label>
            </div>
            <div className="col-sm-4">
              <Multiselect
                options={availabilityArray}
                isObject={false}
                onRemove={selection1}
                onSelect={selection1}
                selectedValues={selectedAvailability}
              />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-sm-2">
              <label>Popular</label>
            </div>
            <div className="col-sm-4">
              <Switch
                onChange={() => {
                  setPopular(!popular);
                }}
                checked={popular}
              />
            </div>
            <div className="col-sm-2">
              <label>New</label>
            </div>
            <div className="col-sm-4">
              <Switch
                onChange={() => {
                  setNewItem(!newItem);
                }}
                checked={newItem}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <strong>Product Images</strong>
          {updateStatus&&image.length!==0&&(
          <button className="btn btn-primary" onClick={()=>{updateImage()}}>Update</button>

          )}
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-range">
                Gallery Image(600×600)
              </label>
            </div>
            <div className="col-sm-10">
              <input
                multiple
                type="file"
                className="profilePic col-sm-12"
                onChange={(e) => {
                  const reader = new FileReader();
                  reader.readAsDataURL(e.target.files[0]);
                  setImage([...image, e.target.files[0]]);
                  if (e.target.files[0]) {
                    const reader = new FileReader();
                    reader.addEventListener("load", () => {
                      setGalleryImg([...galleryImg, reader.result]);
                      if(updateStatus){
                        setImageUpdateStatus(true)
                        setGalleryUpdateImg([...galleryUpdateImg, reader.result]);
                      }
                    });
                    reader.readAsDataURL(e.target.files[0]);
                  }
                }}
              />
              <div className="row">
                {imageUpdateStatus?(
                  <>
                    {galleryUpdateImg.length !== 0 &&
                  galleryUpdateImg.map((val) => {
                    return (
                      <div
                        className=" mt-2 col-sm-3"
                        style={{
                          marginTop: "5px",
                          width: 180,
                          height: 100,
                          aspectRatio: 1 * 1.4,
                        }}
                      >
                        <img
                          alt=""
                          style={{
                            resizeMode: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                          className="playerProfilePic_home_tile"
                          src={val}
                        />
                      </div>
                    );
                  })}</>
                ):(<>
                
                {galleryImg.length !== 0 &&
                  galleryImg.map((val) => {
                    return (
                      <div
                        className=" mt-2 col-sm-3"
                        style={{
                          marginTop: "5px",
                          width: 180,
                          height: 100,
                          aspectRatio: 1 * 1.4,
                        }}
                      >
                        <img
                          alt=""
                          style={{
                            resizeMode: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                          className="playerProfilePic_home_tile"
                          src={val}
                        />
                      </div>
                    );
                  })}</>)}
              
              </div>

              <div className="mt-3">
                {updateStatus? <small class="text-white">
                  Please upload the images to update 
                </small>: <small class="text-white">
                  These images are visible in product details page gallery. Use
                  600x600 sizes images.
                </small>}
               
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <strong>Product price</strong>
        </div>
        <div className="card-body">
        <div className="row mt-3">
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
               Select City
              </label>
            </div>
            <div className="col-sm-4">
              <Select value={city} options={cityObject} setValues={setCity} />
            </div>
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                 Price<span className="text-danger">*</span>
              </label>
            </div>

            <div className="col-sm-4">
              <Input
                type="number"
                defaultName={cost}
                setName={setCost}
                placeHolder="Enter Price"
              />
            </div>
          </div>
          <div className="row mt-3">
           
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Discount Price<span className="text-danger">*</span>
              </label>
            </div>
            <div className="col-sm-4">
              <Input
                type="number"
                defaultName={discount}
                setName={setDiscount}
                placeHolder="enter discount price"
              />
            </div>
            <div className="col-sm-2 mt-1">
               <button
               onClick={()=>{
                if(updateStatus){
                 updateCityPrice()
                }
                else
                {
                  let data={
                    CityName:city,
                    Price:cost,
                    OfferPrice:discount,
                  }
                  setPricingArray([...pricingArray,data])
                  setCity('')
                  setCost('')
                  setDiscount('')
                }
                
               }}
                className="btn btn-primary p-2" style={{borderRadius:'10px',fontSize:'11px'}}>ADD</button>
            </div>
          </div>
          <div className="mt-3 text-center">
                <small class="text-white ">
                You can Add Multiple city prices by add button
                </small>
              </div>
              {pricingArray.length!==0&&(
                  <Table responsive className="text-white mt-2" >
                  <thead>
                    <tr>
                    <th>
                            <strong>City</strong>
                          </th>
                          <th>
                            <strong>Price</strong>
                          </th>
                          <th>
                            <strong>Discount Price</strong>
                          </th>
                          <th>
                            <strong>Action</strong>
                          </th>
                          
                    </tr>
                  </thead>
                  <tbody>
                    {pricingArray&&pricingArray.map((val,idx)=>{
                      return(
                        <tr>
                        <td>{val.CityName}</td>
                        <td>{val.Price}</td>
                        <td>{val.OfferPrice}</td>
                        <td>  
                    <Link
                      onClick={() =>{
                        setShow(true)
                        setUpdateCost(val.Price)
                        setUpdateDiscount(val.OfferPrice)
                        setPriceId(val._id)
                        setDeleteStatus(false)
                      }}
                      className="btn btn-secondary shadow btn-xs sharp ml-1"
                    >
                      <i className="fa fa-edit"></i>
                    </Link>
                    <Link
                      onClick={() =>{
                        if(updateStatus){
                          setPriceId(val._id)
                          setShow(true)
                          setDeleteStatus(true)
                          
                        }else
                        {
                         setPricingArray([...pricingArray.filter((tag) => pricingArray.indexOf(tag) !== idx)]);
                        }
                      }}
                      className="btn btn-danger shadow btn-xs sharp ml-1"
                    >
                      <i className="fa fa-close"></i>
                    </Link>
                    </td>
                      </tr>
                      )
                    })}
                   
                  </tbody>
                </Table>
              )}
        
        </div>
      </div>
      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <strong>Product Description</strong>
        </div>
        <div className="card-body">
          <div className="row">
          <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Shef Life<span className="text-danger">*</span>
              </label>
            </div>

            <div className="col-sm-10">
              <textarea
              className="form-control"
               rows={2}
                value={shefLife}
                onChange={(e)=>{setShefLife(e.target.value)}}
                placeholder="Enter shef life "
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-sm-2">
              <label className="col-form-label">Description</label>
            </div>
            <div className="col-sm-10">
              <textarea
              className="form-control"
               rows={4}
                value={productDescription}
                onChange={(e)=>{setProductDescription(e.target.value)}}
                placeholder="Enter product desription "
              />
            </div>
          </div>
        </div>
      </div>
     <div className="text-center mb-5">
      {updateStatus?<button className="btn btn-primary" onClick={()=>{updateProduct()}}>Update</button>:<button className="btn btn-primary" onClick={()=>{createProduct()}}>Submit</button>}
     </div> 
    </>
  );
}
